export default function removeQueryParamters(path: string): string {
    const queryStringIndex = path.indexOf('?');
    return queryStringIndex > -1 ? path.substring(0, queryStringIndex) : path;
}
